import BaseModel from "./BaseModel";

export default class Project extends BaseModel {}
